var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "15143637-5000-4824-B855-339FA6556449") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Chat_Detail",
    transform: "translate(-881.000000, -979.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(191.000000, 668.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-Textfield",
    transform: "translate(0.000000, 296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(690.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send-2",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.657915947,19.5124602 C1.99724319,24.0970484 5.53518427,27.7657315 10.0847547,29.2178322 C13.3101861,30.24742 16.4541532,30.2152022 19.2561547,29.3867454 C22.4074858,28.4551917 25.7139212,28.1739766 28.9605241,28.6797955 L29.9997684,28.8418049 L29.8925302,28.4542712 C28.9614446,25.0888953 28.9411936,21.5578281 29.669309,18.1427448 C29.9150824,16.9916501 30.0287641,15.7917684 29.9928646,14.5592087 C29.7673422,6.68518656 23.3666467,0.260963909 15.4936116,0.00782431473 C15.3394279,0.00276152285 15.1857044,0.000460253808 15.0324412,0 C5.23280008,0.0230126904 -2.32220224,9.3132358 0.657915947,19.5124602 Z",
    id: "Fill-13",
    fill: "#333D6C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 7.500000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.449196237,6.81878286 C-0.176787393,6.53338934 -0.140047123,5.60959808 0.506519317,5.37746083 L15.4842345,-5.41788836e-14 L6.19424528,9.43802027 L0.449196237,6.81878286 Z M16.5,1.09204422 L11.4688323,15.9951095 C11.2512581,16.6395968 10.3854203,16.6762189 10.1179307,16.0522482 L7.61538462,10.2145793 L16.5,1.09204422 Z"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.6eeeaca709752414aeb0def18158f4b9.svg";
export { ForwardRef as ReactComponent };